import '../css/style.scss'
import {UIManager} from './ui_html/UIManager'
import {EntryShared, socket, uiGameManager} from '../../shared/scripts/EntryShared'
import {SocketWebActionController} from './SocketActionController'
import {EntryHomepageUrlParameterController} from './EntryHomepageUrlParameterController'
import {UIWNotificationController} from './notifications/UIWNotificationController'
import {UIWGameManager} from './ui_game/UIWGameManager'
import {UIWGeneralServicesController} from './UIWGeneralServicesController'
import {Scene} from './ui_html/UISceneTypes'
import {registerWebRoomClientHandlers} from './WebRoomClientHandlers.ts'
import {registerSharedRoomClientHandlers} from '../../shared/scripts/SharedRoomClientHandlers.ts'

export let uiManager: UIManager

export class EntryHomepage extends EntryShared {
    protected socketActionController: SocketWebActionController

    async initialize() {
        await this.initializeSoundAndVersionController()

        await EntryShared.initializeEntry()
        this.webGLCheck()

        uiManager = new UIManager()
        this.initializeUIManagerEvents(uiManager.uiManagerEvents)

        this.initializeGameManager(new UIWGameManager(uiManager.adController))
        this.initializeNotification(new UIWNotificationController())

        const generalServicesController = new UIWGeneralServicesController(uiManager, uiManager.minimalHeader)
        this.socketActionController = this.createSocketActionController(generalServicesController)
        EntryShared.initializeSocket(this.socketActionController, () => uiManager.sceneController.scene == Scene.Game)

        registerSharedRoomClientHandlers(socket.roomClient)
        registerWebRoomClientHandlers(socket.roomClient, uiManager)

        uiManager.init()
        generalServicesController.init()

        socket.connect()

        await EntryHomepageUrlParameterController.loadParameterEvents()
        await this.completeInitialization()
    }

    // eslint-disable-next-line class-methods-use-this
    protected createSocketActionController(generalServicesController: UIWGeneralServicesController): SocketWebActionController {
        return new SocketWebActionController(uiGameManager, uiManager, generalServicesController)
    }
}
